import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import API from '../../utils/api';
import toast from 'react-hot-toast';
import { format, startOfWeek, addDays } from 'date-fns';
import { es } from 'date-fns/locale';

const num = (v) => parseFloat(v) || 0;

export default function CuadreInventario() {
  const { puedeVer } = useAuth();
  const esAdmin = puedeVer('gerencia', 'administracion');

  if (!esAdmin) return (
    <div style={{ padding: 40, textAlign: 'center', color: '#9CA3AF' }}>
      No tienes permiso para ver este módulo.
    </div>
  );

  const hoy = format(new Date(), 'yyyy-MM-dd');
  const lunesActual = format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd');

  const [tab, setTab]               = useState('diario');
  const [bodegas, setBodegas]       = useState([]);
  const [bodegaId, setBodegaId]     = useState('');
  const [fecha, setFecha]           = useState(hoy);
  const [semana, setSemana]         = useState(lunesActual);
  const [cuadre, setCuadre]         = useState(null);
  const [semanal, setSemanal]       = useState(null);
  const [cargando, setCargando]     = useState(false);

  useEffect(() => {
    API.get('/bodegas').then(r => {
      const pvs = r.data.filter(b => b.tipo === 'punto_venta');
      setBodegas(pvs);
      if (pvs.length) setBodegaId(String(pvs[0].id));
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!bodegaId) return;
    if (tab === 'diario') cargarDiario();
    if (tab === 'semanal') cargarSemanal();
  }, [tab, bodegaId, fecha, semana]);

  const cargarDiario = () => {
    setCargando(true);
    setCuadre(null);
    API.get('/cuadre/diario', { params: { bodega_id: bodegaId, fecha } })
      .then(r => setCuadre(r.data))
      .catch(() => toast.error('Error cargando cuadre diario'))
      .finally(() => setCargando(false));
  };

  const cargarSemanal = () => {
    setCargando(true);
    setSemanal(null);
    API.get('/cuadre/semanal', { params: { bodega_id: bodegaId, semana_inicio: semana } })
      .then(r => setSemanal(r.data))
      .catch(() => toast.error('Error cargando cuadre semanal'))
      .finally(() => setCargando(false));
  };

  const bodegaNombre = bodegas.find(b => String(b.id) === String(bodegaId))?.nombre || '';

  // Stats diario
  const alertas = cuadre?.cuadre?.filter(c => c.alerta) || [];
  const conDatos = cuadre?.cuadre?.filter(c => c.real !== null) || [];
  const sinDatos = cuadre?.cuadre?.filter(c => c.real === null) || [];

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", maxWidth: 1100, margin: '0 auto' }}>
      {/* Header */}
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: '#111827' }}>⚖️ Cuadre de Inventario</h1>
        <p style={{ margin: '4px 0 0', color: '#6B7280', fontSize: 14 }}>Contraste entre inventario esperado y real por punto de venta</p>
      </div>

      {/* Controles */}
      <div style={{ background: 'white', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 18, display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        {/* Tabs */}
        <div style={{ display: 'flex', background: '#F3F4F6', borderRadius: 8, padding: 2 }}>
          {[{ id: 'diario', label: '📅 Diario' }, { id: 'semanal', label: '📆 Semanal' }].map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{
              padding: '7px 18px', border: 'none', borderRadius: 7, cursor: 'pointer', fontSize: 13,
              fontWeight: tab === t.id ? 700 : 500,
              background: tab === t.id ? 'white' : 'transparent',
              color: tab === t.id ? '#111827' : '#6B7280',
              boxShadow: tab === t.id ? '0 1px 3px rgba(0,0,0,0.1)' : 'none'
            }}>{t.label}</button>
          ))}
        </div>

        {/* Bodega */}
        <div>
          <div style={st.label}>Punto de venta</div>
          <select value={bodegaId} onChange={e => setBodegaId(e.target.value)} style={st.input}>
            {bodegas.map(b => <option key={b.id} value={b.id}>{b.nombre}</option>)}
          </select>
        </div>

        {/* Fecha / Semana */}
        {tab === 'diario' ? (
          <div>
            <div style={st.label}>Fecha</div>
            <input type="date" value={fecha} onChange={e => setFecha(e.target.value)} max={hoy} style={st.input} />
          </div>
        ) : (
          <div>
            <div style={st.label}>Semana (lunes)</div>
            <input type="date" value={semana} onChange={e => setSemana(e.target.value)} max={hoy} style={st.input} />
          </div>
        )}

        {cargando && <span style={{ fontSize: 13, color: '#6B7280', alignSelf: 'center' }}>⏳ Calculando...</span>}
      </div>

      {/* ── CUADRE DIARIO ── */}
      {tab === 'diario' && cuadre && (
        <>
          {/* Alertas */}
          {alertas.length > 0 && (
            <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 12, padding: '14px 18px', marginBottom: 16 }}>
              <div style={{ fontWeight: 800, color: '#991B1B', fontSize: 15, marginBottom: 8 }}>
                ⚠️ {alertas.length} diferencia{alertas.length > 1 ? 's' : ''} significativa{alertas.length > 1 ? 's' : ''}
              </div>
              {alertas.map(a => (
                <div key={a.item_id} style={{ fontSize: 13, color: '#7F1D1D', padding: '2px 0' }}>
                  • <strong>{a.nombre}</strong>: {a.diferencia > 0 ? '+' : ''}{a.diferencia} {a.unidad} ({a.diferencia > 0 ? 'sobrante' : 'faltante'})
                </div>
              ))}
            </div>
          )}

          {/* Stats rápidos */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px,1fr))', gap: 12, marginBottom: 18 }}>
            {[
              { label: 'Ítems cuadrados', valor: conDatos.length, icon: '✅', color: '#10B981' },
              { label: 'Sin conteo físico', valor: sinDatos.length, icon: '⏳', color: '#F59E0B' },
              { label: 'Con diferencia', valor: alertas.length, icon: '⚠️', color: '#EF4444' },
            ].map((s, i) => (
              <div key={i} style={{ background: 'white', borderRadius: 12, padding: '14px 16px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
                <div style={{ fontSize: 20, marginBottom: 6 }}>{s.icon}</div>
                <div style={{ fontWeight: 800, fontSize: 22, color: s.color }}>{s.valor}</div>
                <div style={{ fontSize: 11, color: '#9CA3AF', fontWeight: 600, marginTop: 2 }}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* Tabla cuadre diario */}
          <div style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
            <div style={{ background: '#1a1a2e', padding: '12px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ color: 'white', fontWeight: 800, fontSize: 14 }}>
                📅 Cuadre diario — {bodegaNombre} — {fecha ? format(new Date(fecha + 'T12:00'), "d 'de' MMMM yyyy", { locale: es }) : ''}
              </div>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    {['Ítem', 'Unidad', 'Inicial', 'Entradas', 'Salidas POS', 'Salidas Aliaddo', 'Esperado', 'Real', 'Diferencia'].map(h => (
                      <th key={h} style={{ padding: '10px 12px', textAlign: h === 'Ítem' || h === 'Unidad' ? 'left' : 'right', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cuadre.cuadre.map((c, i) => {
                    const sinReal = c.real === null;
                    const rowBg = c.alerta ? '#FEF2F2' : sinReal ? '#FFFBEB' : i % 2 === 0 ? 'white' : '#FAFAFA';
                    const difColor = c.diferencia === null ? '#9CA3AF' : Math.abs(c.diferencia) < 0.01 ? '#10B981' : c.diferencia > 0 ? '#F59E0B' : '#EF4444';
                    return (
                      <tr key={c.item_id} style={{ borderTop: '1px solid #F3F4F6', background: rowBg }}>
                        <td style={{ padding: '10px 12px', fontWeight: 600 }}>
                          {c.alerta && <span style={{ color: '#EF4444', marginRight: 4 }}>⚠️</span>}
                          {c.nombre}
                        </td>
                        <td style={{ padding: '10px 12px', color: '#9CA3AF', fontSize: 11 }}>{c.unidad}</td>
                        <td style={{ padding: '10px 12px', textAlign: 'right', color: '#6B7280' }}>{c.inicial}</td>
                        <td style={{ padding: '10px 12px', textAlign: 'right', color: c.entradas > 0 ? '#10B981' : '#6B7280', fontWeight: c.entradas > 0 ? 700 : 400 }}>
                          {c.entradas > 0 ? `+${c.entradas}` : '—'}
                        </td>
                        <td style={{ padding: '10px 12px', textAlign: 'right', color: c.salidas_pos > 0 ? '#EF4444' : '#6B7280' }}>
                          {c.salidas_pos > 0 ? `-${c.salidas_pos}` : '—'}
                        </td>
                        <td style={{ padding: '10px 12px', textAlign: 'right', color: c.salidas_aliaddo > 0 ? '#EF4444' : '#6B7280' }}>
                          {c.salidas_aliaddo > 0 ? `-${c.salidas_aliaddo}` : '—'}
                        </td>
                        <td style={{ padding: '10px 12px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 700 }}>{c.esperado}</td>
                        <td style={{ padding: '10px 12px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, color: sinReal ? '#9CA3AF' : '#111827' }}>
                          {sinReal ? '—' : c.real}
                        </td>
                        <td style={{ padding: '10px 12px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, color: difColor }}>
                          {c.diferencia === null ? '—' : c.diferencia === 0 ? '✅' : `${c.diferencia > 0 ? '+' : ''}${c.diferencia}`}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}

      {/* ── CUADRE SEMANAL ── */}
      {tab === 'semanal' && semanal && (
        <div style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
          <div style={{ background: '#1a1a2e', padding: '12px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ color: 'white', fontWeight: 800, fontSize: 14 }}>
              📆 Consumo semanal — {bodegaNombre}
            </div>
            <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12 }}>
              {semana ? format(new Date(semana + 'T12:00'), "d MMM", { locale: es }) : ''} — {semanal.fin ? format(new Date(semanal.fin + 'T12:00'), "d MMM yyyy", { locale: es }) : ''}
            </div>
          </div>

          {/* Agrupar por categoría */}
          {(() => {
            const porCat = {};
            semanal.resultado.forEach(r => {
              if (!porCat[r.categoria]) porCat[r.categoria] = [];
              porCat[r.categoria].push(r);
            });
            return Object.entries(porCat).map(([cat, items]) => (
              <div key={cat}>
                <div style={{ padding: '10px 16px', background: '#F3F4F6', fontWeight: 700, fontSize: 12, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                  {cat}
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <tbody>
                    {items.filter(i => i.consumo_teorico > 0).sort((a, b) => b.consumo_teorico - a.consumo_teorico).map((item, i) => (
                      <tr key={item.mp_id} style={{ borderTop: '1px solid #F3F4F6', background: i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                        <td style={{ padding: '10px 16px', fontWeight: 600 }}>{item.nombre}</td>
                        <td style={{ padding: '10px 16px', color: '#9CA3AF', fontSize: 11 }}>{item.unidad}</td>
                        <td style={{ padding: '10px 16px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, color: '#EF4444', fontSize: 14 }}>
                          {Math.round(item.consumo_teorico)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ));
          })()}

          {semanal.resultado.every(r => r.consumo_teorico === 0) && (
            <div style={{ padding: 32, textAlign: 'center', color: '#9CA3AF' }}>Sin ventas registradas para esta semana.</div>
          )}
        </div>
      )}

      {!cargando && !cuadre && !semanal && (
        <div style={{ background: 'white', borderRadius: 14, padding: 40, textAlign: 'center', color: '#9CA3AF', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
          Selecciona un punto de venta y fecha para ver el cuadre.
        </div>
      )}
    </div>
  );
}

const st = {
  label: { fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 },
  input: { padding: '8px 12px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 13, outline: 'none', background: 'white' },
};
